import { faHandshake } from '@fortawesome/pro-solid-svg-icons';
import {
  StrategyConfig,
  StrategyValidationContext,
  CreateStrategyPayload,
  UpdateStrategyPayload,
} from '../types';
import {
  validateDynamicCriteria,
  hasUnfilledCriteriaPlaceholders,
} from '../../Admin/utils/strategyValidation';
import ReferralsConfiguration from '../../Admin/AddEditStrategy/components/StrategyTypes/ReferralsConfiguration';
import { transformCriteriaInputs } from './transformers';

/**
 * Configuration for Referrals strategy type
 *
 * Referrals engages/expands providers based on their referral patterns
 * and relationships. Uses dynamic criteria templates.
 */
export const referralsConfig: StrategyConfig = {
  type: 'REFERRALS',
  label: 'Referrals',
  description:
    'Engage/Expand providers based on their referral patterns and relationships',
  icon: faHandshake,
  mode: 'engage',
  disabled: false,

  ConfigComponent: ReferralsConfiguration,

  requiredFields: ['label', 'description', 'criteria_template'],

  validateProgress: (context: StrategyValidationContext): boolean => {
    if (context.isEditMode || context.isCopyMode) {
      return !!(
        context.strategyDetails?.criteria_template ||
        context.strategyDetails?.codeSetId ||
        context.strategyDetails?.mode
      );
    }
    const template = context.dynamicCriteria?.criteria_template;
    // Check that template exists and all placeholders have valid data
    return !!template && !hasUnfilledCriteriaPlaceholders(context.dynamicCriteria);
  },

  validateComplete: (context: StrategyValidationContext): boolean => {
    if (context.isEditMode || context.isCopyMode) return true;
    return validateDynamicCriteria(context.dynamicCriteria);
  },

  serializeForCreate: (
    context: StrategyValidationContext
  ): CreateStrategyPayload => {
    return {
      label: context.formData.label,
      description: context.formData.description,
      type: 'REFERRALS',
      max_opportunities: context.formData.max_opportunities,
      criteria_template: context.dynamicCriteria?.criteria_template || '',
      criteria_inputs: transformCriteriaInputs(
        context.dynamicCriteria?.criteria_inputs
      ),
    };
  },

  serializeForUpdate: (
    context: StrategyValidationContext
  ): UpdateStrategyPayload => {
    return {
      label: context.formData.label,
      description: context.formData.description,
      max_opportunities: context.formData.max_opportunities,
      criteria_template: context.dynamicCriteria?.criteria_template || '',
      criteria_inputs: transformCriteriaInputs(
        context.dynamicCriteria?.criteria_inputs
      ),
    };
  },

  features: {
    hasMaxOpportunities: true,
  },
};
